import { get } from '@/service/Axios'

const state = () => ({
  expired: {}
})

const mutations = {
  setExpired (state, expired) {
    state.expired = expired || {}
  }
}

const actions = {
  async getExpired ({ commit }) {
    const { data } = await get(`users/check/time`, {
      params: {
        email: this.state.email
      }
    })
    commit('setExpired', data.data)
    return data
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}